module.exports = __webpack_public_path__ + "static/media/15UN-Habitat4.bbd558af.jpg";